import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useCrudEditContext, useDynamicFormsTranslate } from "@ryde/redux";
import {
  EditFormTemplateType,
  getComputedFormFieldName,
  ICustomField,
  IExtendableDto,
  translateGridValue,
} from "@ryde/shared";

import { GenericReadonly } from "../../common";

interface IGenericReadonlyTemplateProps extends ICustomField {
  controlInfoName?: EditFormTemplateType;
}

export const GenericReadonlyTemplate: FC<IGenericReadonlyTemplateProps> = ({
  name,
  formLabel,
  formAttributes,
  gridAttributes,
  isColumn,
}) => {
  const { t } = useTranslation();
  const {
    data: { dto },
  } = useCrudEditContext<IExtendableDto>();
  const { control } = useFormContext();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });
  const fieldName = getComputedFormFieldName({
    name,
    formAttributes,
    isColumn,
  });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ...fieldRest }, fieldState: { error } }) => {
        return (
          <GenericReadonly
            label={formLabelTranslated}
            value={String(
              translateGridValue({
                valueToProcess: dto?.[fieldName] ?? value,
                gridAttributes,
                formAttributes,
                skipBooleanSelectListLabelConversion: true,
                t,
              }),
            )}
          />
        );
      }}
    />
  );
};
